$(document).ready(function () { 
  if ($(".case-study-archive-filter").length) {
    $(".case-study-archive-filter ul li a").click(function() {
      filterCaseStudies(this);
    });

    $(".case-study-archive-filter .case-study-filter").change(function() {
      filterCaseStudies(this);
    });
  }
});

function filterCaseStudies(filterElement) {
  var $element = $(filterElement);
  var filterOn = "";
  if ($element.is("a")) {
    filterOn = $element.data("service-name");
    $(".case-study-archive-filter .case-study-list a").removeClass("active");
    $element.addClass("active");
    $(".case-study-archive-filter .case-study-filter").val(filterOn);
  }
  if ($element.is("select")) {
    filterOn = $element.find("option:selected").val();
    $(".case-study-archive-filter .case-study-list a").removeClass("active");
    $(".case-study-archive-filter .case-study-list a[data-service-name='"+filterOn+"']").addClass("active");
  }

  filterStudies(filterOn);
}

function filterStudies(filterOn) {
  $caseStudies = $(".case-study-grid-section .case-study-col");
  $caseStudies.each(function () {
    var categories = $(this).data("study-categories");
    if (categories.includes(filterOn)) {
      $(this).removeClass("hidden");
    } else {
      $(this).addClass("hidden");
    }
  });
}